<div class="highlighted-topline highlighted-topline--connection"
     *ngIf="truncate && firstConnection">
  <strong class="color--gray--005 txt-fw-500">
    {{getConnectedToEntity(firstConnection) | fullName}}
  </strong>

  <ng-container *ngIf="firstConnection?.appliedToplines?.item0?.toplineItem">
    <app-highlighted-topline [targetType]="'EntityConnection'"
                             [targetId]="firstConnection.id"
                             [campaignId]="firstConnection.campaignId"
                             [parentEntityId]="parentEntityId"
                             [topline]="firstConnection?.appliedToplines?.item0"></app-highlighted-topline>
  </ng-container>
</div>

<ng-container *ngIf="!truncate">
  <!-- No connections-->
  <ng-container *ngIf="connections.length === 0">
    <div class="toplines__pair toplines__pair--tags toplines__pair--connections col__ flexAlign--baseline">
      <div class="pair__icon">
        <i class="fal fa-fw fa-share-alt"
           [matTooltip]="connectionName"></i>
        <span class="screen-reader">{{connectionName}}</span>
      </div>
      <div class="pair__content">
        <span (click)="onAddClicked()"
              class="pair__link link link--noline"
              data-test-id="toplineAddEmailLink">Add {{connectionName}} Connection</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let connection of connections">
    <div class="toplines__pair toplines__pair--tags toplines__pair--connections col__ flexAlign--baseline">
      <div class="pair__icon">
        <i class="fal fa-fw fa-share-alt"
           [matTooltip]="connectionName"></i>
        <span class="screen-reader">{{connectionName}}</span>
      </div>
      <div class="pair__content">
        <div class="mb-0050 topline-connection__title">{{getConnectedToEntity(connection) | fullName}}</div>
        <!-- Recurisvely display the toplines for this connection-->
        <app-toplines-display [appliedToplines]="connection?.appliedToplines"
                              (addClick)="passThroughClick($event)"
                              [targetType]="'EntityConnection'"
                              [targetId]="connection?.id"></app-toplines-display>
      </div>
    </div>
  </ng-container>
</ng-container>
